import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NowGeneralContextProvider } from '../../../../now'
import {
  ProductSearchPagination,
  ProductSearchRefinements,
  ProductSearchRefinementsButton,
  ProductSearchRefinementSortingSelect,
  ProductSearchRefinementStateProvider,
  ProductSearchResultInfo,
} from '../../../../product-search'
import { useStoryblokStory } from '../../../context/StoryblokStoryContext'
import { StoryblokAlgoliaSearch } from '../../StoryblokAlgoliaSearch/StoryblokAlgoliaSearch'
import { storyblokProductSearchFiltersGetQuery } from '../../StoryblokProductSearchFilters'

import { StoryblokCategoryProductSearchResults } from './StoryblokCategoryProductSearchResults'

export const StoryblokCategoryProductSearch: FC = () => {
  const {
    content: { akeneoCategoryCode, component, productSearchFilters },
  } = useStoryblokStory()

  if (component !== 'AkeneoCategoryPage') {
    throw new Error(
      'StoryblokCategoryProductSearch can only be used on AkeneoCategoryPage component',
    )
  }

  const categoryFilters = storyblokProductSearchFiltersGetQuery({
    defaultFilters: {
      categoryCodes: akeneoCategoryCode ? [akeneoCategoryCode] : [],
      stockStatusReason: [
        'product.stockStatus.available',
        'product.stockStatus.nl',
      ],
    },
    productSearchFilters,
  })

  /* eslint-disable react/jsx-max-depth -- it's a page with multiple providers */
  return (
    <NowGeneralContextProvider>
      <StoryblokAlgoliaSearch filters={categoryFilters}>
        <div
          className="flex flex-col gap-3 desktop:gap-6"
          data-qa-id="category-page-search"
        >
          <div className="flex flex-col gap-3 desktop:gap-6">
            <ProductSearchRefinementsButton className="desktop:hidden" />
            <ProductSearchResultInfo />
          </div>
          <div className="grid gap-4 pt-5 desktop:grid-cols-10 desktop:items-start desktop:gap-6 desktop:pt-0">
            <div className="hidden flex-col gap-6 rounded-lg bg-light-primary-medium p-4 desktop:col-span-3 desktop:flex">
              <h5 className="text-l font-medium">
                <FormattedMessage id="general.label.filterSearch" />
              </h5>
              <div className="flex flex-col gap-4">
                <ProductSearchRefinementStateProvider>
                  <ProductSearchRefinementSortingSelect />
                  <ProductSearchRefinements />
                </ProductSearchRefinementStateProvider>
              </div>
            </div>
            <div className="desktop:col-span-7">
              <StoryblokCategoryProductSearchResults />
              <ProductSearchPagination />
            </div>
          </div>
        </div>
      </StoryblokAlgoliaSearch>
    </NowGeneralContextProvider>
  )
  /* eslint-enable react/jsx-max-depth */
}
